const Data = [
    {
        name: "Ujjwal Kumar Singh",
        position: "Design Head",
        imageUrl: "/assets/images/members/Heads23/ujjawal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100074018137550&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/ujjwalkumarsingh?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "ujjwal.singh@gyws.org"
    },
    {
        name: "Yash Mate",
        position: "Design Head",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Divyanshu Singh",
        position: "Design Head",
        imageUrl: "/assets/images/members/Heads23/divyanshu.jpg",
        facebookLink: "https://www.facebook.com/Divyanshu.singh15",
        linkedinLink: "https://www.linkedin.com/in/divyanshu-singh15",
        email: "divyanshu.singh@gyws.org"
    },
]

export default Data;